import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CalloutComponent, CalloutPlacement } from '@freelancer/ui/callout';
import { HoverColor } from '@freelancer/ui/icon';
import { LinkColor } from '@freelancer/ui/link';
import { Margin } from '@freelancer/ui/margin';
import { TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-user-profile-editable-ui-drop-actions',
  template: `
    <fl-callout
      #callout
      [hover]="true"
      [hideArrow]="true"
      [placement]="CalloutPlacement.BOTTOM"
      [hideCloseButton]="true"
    >
      <fl-callout-trigger
        title="More Actions"
        i18n-title="More actions alt text"
      >
        <fl-icon
          [hoverColor]="HoverColor.PRIMARY"
          [name]="'ui-show-more-h'"
        ></fl-icon>
      </fl-callout-trigger>

      <fl-callout-content>
        <fl-bit class="Actions">
          <fl-link
            i18n="Edit drop action link"
            [flTrackingLabel]="flTrackingLabel + 'EditDropdownAction'"
            [color]="LinkColor.DARK"
            [size]="TextSize.SMALL"
            [flMarginBottom]="Margin.SMALL"
            (click)="handleActionEdit()"
          >
            Edit
          </fl-link>
          <fl-link
            i18n="Delete drop action link"
            [flTrackingLabel]="flTrackingLabel + 'DeleteDropdownAction'"
            [color]="LinkColor.DARK"
            [size]="TextSize.SMALL"
            (click)="handleActionDelete()"
          >
            Delete
          </fl-link>
        </fl-bit>
      </fl-callout-content>
    </fl-callout>
  `,
  styleUrls: ['./user-profile-editable-ui-drop-actions.component.scss'],
})
export class UserProfileEditableUiDropActionsComponent {
  CalloutPlacement = CalloutPlacement;
  TextSize = TextSize;
  HoverColor = HoverColor;
  LinkColor = LinkColor;
  Margin = Margin;

  @Input() flTrackingLabel: string;

  @Output() edit = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  // This is needed to manually close the callout on mobile.
  @ViewChild('callout') callout: CalloutComponent;

  handleActionEdit(): void {
    this.callout.close();
    this.edit.emit();
  }

  handleActionDelete(): void {
    this.callout.close();
    this.delete.emit();
  }
}
